import { render, staticRenderFns } from "./ItemViewPlaceholder.vue?vue&type=template&id=6399f07f&scoped=true&"
import script from "./ItemViewPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ItemViewPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ItemViewPlaceholder.vue?vue&type=style&index=0&id=6399f07f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399f07f",
  null
  
)

export default component.exports